import { render, staticRenderFns } from "./List-News.vue?vue&type=template&id=51bd1652"
import script from "./List-News.vue?vue&type=script&lang=js"
export * from "./List-News.vue?vue&type=script&lang=js"
import style0 from "./List-News.vue?vue&type=style&index=0&id=51bd1652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports